import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WellDetailsModel } from '../_models/well-details-model';
import { FormationService } from '../_services/formation.service';
import { Formation } from '../_models/formation';
import { FormGroup, AbstractControl, FormBuilder } from '@angular/forms';
import { debounceTime, filter } from 'rxjs/operators';

@Component({
  selector: 'app-edit-formations-dialog',
  templateUrl: './edit-formations-dialog.component.html',
  styleUrls: ['./edit-formations-dialog.component.css']
})
export class EditFormationsDialogComponent implements OnInit {

  public well: WellDetailsModel;

  public selectedFormations: Array<any> = new Array<Formation>();
  public formationCandidates: Array<any> = new Array<Formation>();

  public formationsForm: FormGroup;

  public formationsFormModel: any = {
    searchFormationName: ""
  };

  public isUnchanged: boolean = true;

  get isReadyForSave(): boolean {
    var ret: boolean = false;

    if (this.selectedFormations != null && this.selectedFormations.length > 0) {
      ret = true;
    }

    return ret;
  }

  constructor(
    public dialogRef: MatDialogRef<EditFormationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public formationService: FormationService,
    protected formBuilder: FormBuilder
  ) {
    this.well = this.data.well;

    var sf = [];

    //Copy the array of formations so we can cancel without it actually changing.
    for (var i = 0; i < this.data.well.Formations.length; i++) {
      var f = this.data.well.Formations[i];

      sf.push(f);
    }

    this.selectedFormations = sf;


    function selectedFormationsValidator() {
      return (control: AbstractControl) => {
        var ret: any = {};

        var formationsArray = control.value;

        if (formationsArray != null && formationsArray.length != null && formationsArray.length == 0) {
          ret.noOperators = true;
        }

        return ret;
      };
    }


    this.formationsForm = this.formBuilder.group({
      'searchFormationName': [this.formationsFormModel.searchFormationName, []],
      'selectedFormations': [this.selectedFormations, [selectedFormationsValidator()]]
    });

    
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    this.formationsForm.get("searchFormationName").valueChanges.pipe(filter((val) => val.length === 6),
      debounceTime(500)).subscribe((x) => {
        this.updateFormationResults(x);
      });

  }

  public updateFormationResults(formationName: string) {
    //Perform the search
    this.formationService.searchByName(formationName).then((formationCandidates: Array<Formation>) => {
      this.formationCandidates = formationCandidates;
    },
      (err) => {
      });
  }



  public selectFormation(formation: Formation) {
    var found = this.selectedFormations.find((x: Formation) => {
      var ret = false;

      if (x.Id == formation.Id) {
        ret = true;
      }

      return ret;
    });

    if (found == null) {
      this.selectedFormations.push(formation);

      this.formationsForm.get("selectedFormations").setValue(this.selectedFormations);

      this.isUnchanged = false;
    }
  }

  public removeFormation(formation: Formation) {
    var ind = this.selectedFormations.indexOf(formation);

    this.selectedFormations.splice(ind, 1);

    this.formationsForm.get("selectedFormations").setValue(this.selectedFormations);

    this.isUnchanged = false;
  }

  public saveChanges() {
    this.dialogRef.close(this.selectedFormations);
  }
}
